import { useState } from 'react';
import { NJIconButton, NJMenu, NJText } from '@engie-group/fluid-design-system-react';

export function CommentAvatar({ name }: { name: string }) {
  return <div className="studio-comment-avatar" aria-hidden="true">
    <NJText as="span" scale="xs">{name.trim().charAt(0).toUpperCase() || '?'}</NJText>
  </div>;
}

export function CommentMenu({ onEdit, onMove, onDelete, disabled = false, thread = false }: {
  onEdit?: () => void; onMove?: () => void; onDelete: () => void; disabled?: boolean; thread?: boolean;
}) {
  const [opened, setOpened] = useState(false);
  const run = (action: () => void) => { setOpened(false); action(); };
  return (
    <NJMenu.Root opened={opened} onOpen={setOpened}>
      <NJMenu.Anchor>
        <NJIconButton label={thread ? 'Actions de la discussion' : 'Actions du commentaire'}
          title={thread ? 'Actions de la discussion' : 'Actions du commentaire'}
          icon="more_horiz" variant="tertiary" scale="sm" isDisabled={disabled} />
      </NJMenu.Anchor>
      <NJMenu.Dropdown data-comment-ui style={{ zIndex: 1100 }}>
        <NJMenu.Group>
          {onEdit && <NJMenu.Item label="Modifier" onClick={() => run(onEdit)}>Modifier</NJMenu.Item>}
          {onMove && <NJMenu.Item label="Repositionner" onClick={() => run(onMove)}>Repositionner</NJMenu.Item>}
          <NJMenu.Item label={thread ? 'Supprimer la discussion' : 'Supprimer le commentaire'}
            onClick={() => run(onDelete)}>{thread ? 'Supprimer la discussion' : 'Supprimer le commentaire'}</NJMenu.Item>
        </NJMenu.Group>
      </NJMenu.Dropdown>
    </NJMenu.Root>
  );
}
